
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqk3B1Uxtkqcdqfxz8SFgUtVB7eqfqJjYMsirqYU53KKAMeta } from "/codebuild/output/src3834588611/src/src/pages/faq.vue?macro=true";
import { default as menu5BlCa54xG_57RNt1eUDbDk597RTCQ3_45LfumC3rS7q4QMeta } from "/codebuild/output/src3834588611/src/src/pages/menu.vue?macro=true";
import { default as indexEcbSv9HgEo58lYeffNC6yi5C8sptIganIEp9co1XCuwMeta } from "/codebuild/output/src3834588611/src/src/pages/index.vue?macro=true";
import { default as contactP_9eqhR_ocSsanCpXE8YE7TwMZFKOiQbNYydnorbDoAMeta } from "/codebuild/output/src3834588611/src/src/pages/contact.vue?macro=true";
import { default as tutorialkBMPmeahF17xqw_45VxdLaTMatZ7jVi5EJrnq4gfST04cMeta } from "/codebuild/output/src3834588611/src/src/pages/tutorial.vue?macro=true";
import { default as agreementC3M_45vPDgokU1jH0_ZMo6I8c2I1d0qWp3IPtGTc8tqSIMeta } from "/codebuild/output/src3834588611/src/src/pages/agreement.vue?macro=true";
import { default as about_45passPwbS76cBWnUKZ_45edYWhu1sJ7MbqOjoFD54cmugZoIVUMeta } from "/codebuild/output/src3834588611/src/src/pages/about-pass.vue?macro=true";
import { default as indexcL0yNm0pSgL8aT7CXMe5UoM0Z5VwdczLfdZQ6bug2B0Meta } from "/codebuild/output/src3834588611/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93__45IZV9pwhNBBqHlvvDsYhTRWjhXcP32Rnp90d0BfAYkMeta } from "/codebuild/output/src3834588611/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceFgoeCOLzg2EVnny6DN5OvZvgFfZFXM5Y_5TqHzys4LgMeta } from "/codebuild/output/src3834588611/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93xfFIajkxzahHYcEZpKOg4fnK7wGdmOGc3h_45D2C_45b9bEMeta } from "/codebuild/output/src3834588611/src/src/pages/notice/[id].vue?macro=true";
import { default as indexDDwkNhDgu9rJK241vzc8JUG20m0g5hYOdwhyNnX5N_sMeta } from "/codebuild/output/src3834588611/src/src/pages/coupon/index.vue?macro=true";
import { default as indexfa7JOMOKvBu5yg1j95g1Gdnd8R8A4os7iLSrjG_mnGMMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/index.vue?macro=true";
import { default as indexMvhh5gWUWHsrm4hZ5hOM1ag5fojVu_45uME7RKRT6dD6EMeta } from "/codebuild/output/src3834588611/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93XJWh8G1rfwO4CvmKvvWRJ6LZtFz_45TMQzZPgAAtz82OkMeta } from "/codebuild/output/src3834588611/src/src/pages/parking/[id].vue?macro=true";
import { default as index7zabZOloLrO1IrK62SH_45x06HcFC7hMliWadSIhNsCJ0Meta } from "/codebuild/output/src3834588611/src/src/pages/history/index.vue?macro=true";
import { default as indexgbOeE3MmzMClX0bfUBoaGj5QrF0MsR73KAPKzfjo6j0Meta } from "/codebuild/output/src3834588611/src/src/pages/monthly/index.vue?macro=true";
import { default as indexX_451__45IWCMij8apVqyA9mE08wivYPcyOo934_45_2nG0YUMeta } from "/codebuild/output/src3834588611/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexRLMJioGKDtRpmwdU0gOmnXarnjEi0QEGxues0qD9COgMeta } from "/codebuild/output/src3834588611/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviJkolpmsfQhwJMRBTRkDGnmEx_45C447IrliwrCWZJbHSwMeta } from "/codebuild/output/src3834588611/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editFcJoDitKlD1qxzAymyda5SB8u078NUFPulgkSyAJBKsMeta } from "/codebuild/output/src3834588611/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementISTwcnW4ALmqH0fZ1hgp1T9Qcxc2OOUjYbNYT7M5D1QMeta } from "/codebuild/output/src3834588611/src/src/pages/pass-agreement.vue?macro=true";
import { default as index0HjF2Q1JrTxxpmG4i76gNAsvrFDHGFTJ8f_2hAlyfRcMeta } from "/codebuild/output/src3834588611/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dRGkJHbXK43g8OQ5WFX_45a_wAQEP__2qNOHFsZ4rsqcLEMeta } from "/codebuild/output/src3834588611/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmyEVbBwoMR5vGbOdVcfnSLHM5gs1uaLttyIyh7XahLWEMeta } from "/codebuild/output/src3834588611/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexKIkMtPReZ6C2PRZ3HaZVy3jj0vVMlkmry3OliMpSDGMMeta } from "/codebuild/output/src3834588611/src/src/pages/card/create/index.vue?macro=true";
import { default as indexq4cCIE6sQ5XaFsVOqPT4tJy1IzK_45YlR2PkaUVsZo_kcMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmCyJtOVn8G5sN3tEe36BYHYO0OJBl7CsXdwjluzKx4wUMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmXyVPJIBD79SCVZEaCoZYySFBxrCz_45s0O0Vh0kf02hhoMeta } from "/codebuild/output/src3834588611/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completewTDXOLkd_Kt3Hbny9Srs6Y36MI1A0l5eOhOd69EZ_hYMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/complete.vue?macro=true";
import { default as registerf9BBMM31IYFM7s9KCkPtN0TDDvwZ4L13jim7frW0OqYMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93LzBT7UoZoGXa1AjPo_XbU86Uz74_45_45PQqyZEsHuDFsmUMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmv4Isuoo9GoAlHFdvAKBQ9JTnAAYq_vHfe_gYH7AYylQMeta } from "/codebuild/output/src3834588611/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93DPm0KEnpx_y6Hj2jMXySypwSaRvcVoJjkPcxxBbPZSYMeta } from "/codebuild/output/src3834588611/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexMdZpv1MmvfV8QE_45KPzV7mSb5JrGjU9C8NenJVyIcBgwMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code0NCln6McSmZ_45y_2fba4abMQN_UtuuCLMF8CIDX0EVycMeta } from "/codebuild/output/src3834588611/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codexH0FAxmEXK0FsbbPLcyrNQARVsWmjZmRATJQQPpFi68Meta } from "/codebuild/output/src3834588611/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeTPTP6qeQd3XHYDFfXH_zM_u5uUX7gkR60PUTbF5wT4EMeta } from "/codebuild/output/src3834588611/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerBcDuUmWdTy2vxbjyu1yjku_tlGGk9JvcSmhcd0d7_SAMeta } from "/codebuild/output/src3834588611/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeKr8mo7qSUvcgExzjcjty3U_456IbB7zPOPEdrp9WpzqqYMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexgJ0dv3i6_qgWb_45o0yM10flqbI_45NXpkzwQZMQokz1aYYMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmP_45Ilu6elWk6xILnBiC3tGnVGy7VjJ8R6mP2Ghwg4w_45UMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeO0WDOi_R97XJutvwxOI4DSpJ_45HEKyQ7BMNDj0ton_wQMeta } from "/codebuild/output/src3834588611/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexEKjyJ3nv8ECx8YD625Ystf4_45TUC6LY1gF268lMHlTGAMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93xt46649imeCfXfFvgyVhHbQkcuBwJAEbWsyvsRMFBVQMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeIvY52QMc2ZGWY_6tFuym8OSB00sAUpNJ6AmuwQlR5owMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasu5kLmLYVh6AwhnXOtf9tx3rJFVqyu1V4bzXmAHD93PEMeta } from "/codebuild/output/src3834588611/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplekKN8oiweXgvzxUojzZTmFMLg1YiRytGy2oLQ2bNoUJwMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email54w6DiLTssCuKePQc3QgibaWHySjFFl5BEFEaAcaaDoMeta } from "/codebuild/output/src3834588611/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmNSnb_45VA7OtjyrEuzIeZN9BPXarisjLWDJDGSy4fMCCoMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentaX12evWfVBPAUHiJT7D0JstHGXBfGTRE7S1oZe8Sb5QMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhig9guEPBBtUqTpiIscyPAULppJv39KQk6IjuVCmimQMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatebz8NfhDYV6VKHVZqeJANXgDx7ZRco8u1NGHJCiisja8Meta } from "/codebuild/output/src3834588611/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeFo4frCV_93hKpFjPL9PFPXKHWaMnXxX2qYTXKk0NKnUMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code81F_C3A0JWgzfSaWhkPQWNVX6_opArJGYwPxiEVFaNwMeta } from "/codebuild/output/src3834588611/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordL6DR7m9sqr9RyOw7ms4fpCVNbdsHQona8iVSr8rihL8Meta } from "/codebuild/output/src3834588611/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasV3sIDrzfl3vDST1fdbRoPj45TKgaalBFD3IoOB1PovsMeta } from "/codebuild/output/src3834588611/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerNPvgA2D04n8vezOB22bsPZjKujrhOVPeoYkptw_Fi_45oMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeUYzFuphbXsqfRE7n9jay_45cjeqiJNv_aQbv_8O3rRebgMeta } from "/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexNhSFQCJEgBLbGVSbobBDnFT5CJaRGnxSoOiff61BzHQMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexMoA_89afNqHCV9A3AsMkB1d2aXMeQPP2DFmGj3RsSGAMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexTg0i4_XwPIqhDabiSH3Sl7HP6iRPdX9Tx_H7p4DUUHUMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexYDZpp79BAwB22UrjR46tG1eUz39Zd_g9IUFifBiEQ7UMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateoywjSvYWl5OagcRhAZj70vVc7LBd4UIxjn0h5AwnBFgMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeLRAMQspfxUnDr4M9jhXo8yzmRug9_45g6zzc8jJVpJ_Y0Meta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmWFZicP2xN1OciMafrzCR9Wn71EqgBi8cK0eYpWaE8qwMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexsF3zmcsgJR5xCGKUGOB0s79P9In9AtnVtf7btP2DtpUMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete6bB6b30SLM_5TQPbpQm3B0Jp7Z5qcTFwm8YDzZxlWb4Meta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateqNnMyCg7tFTdv4_45S2c0_45zIFilYYGw8AAdF9OHIG3LPAMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexf9axqFBQkbDLkhvoQn_45kt5LsNq7iJ9P1zLoBsikhfwcMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexksTsF2umWrOC_7DLQrE41gggZjzinNXM0Abr1WryhhAMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeFo6UpPYZc_45krVGuBLimxOY3DFw1gHsl8PGdAxEs1BrkMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexyD_455EaeTmqsREHQM4sHBAnVBvnfyWzWzHyaAzG_OJ6UMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codemCx8UeIB7trHELobxqQzn6rQcFcfGhqdYMe3TAZ09_45cMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexFAMQBpKTmSS7rv91tPcc_fVxsJFRiaBYOf50vfLiFskMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index10fgAgjyvLDz7c2weDaZbGNuZF3rnRiH4hj28AVd0RUMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexQ0bdkedQNZfArcEfbMvvDArRavvQVOGt805c3vqTbJsMeta } from "/codebuild/output/src3834588611/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updategU7TCuOjoCUSINc_UunTd_1sozhnccZIc05ogMCMHgEMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmaxwUejjmKLDGVhuRaVOikI1NXG9vBIHTAH5VowY797UMeta } from "/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu5BlCa54xG_57RNt1eUDbDk597RTCQ3_45LfumC3rS7q4QMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexEcbSv9HgEo58lYeffNC6yi5C8sptIganIEp9co1XCuwMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexDDwkNhDgu9rJK241vzc8JUG20m0g5hYOdwhyNnX5N_sMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index7zabZOloLrO1IrK62SH_45x06HcFC7hMliWadSIhNsCJ0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexX_451__45IWCMij8apVqyA9mE08wivYPcyOo934_45_2nG0YUMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexRLMJioGKDtRpmwdU0gOmnXarnjEi0QEGxues0qD9COgMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexKIkMtPReZ6C2PRZ3HaZVy3jj0vVMlkmry3OliMpSDGMMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmCyJtOVn8G5sN3tEe36BYHYO0OJBl7CsXdwjluzKx4wUMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmXyVPJIBD79SCVZEaCoZYySFBxrCz_45s0O0Vh0kf02hhoMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completewTDXOLkd_Kt3Hbny9Srs6Y36MI1A0l5eOhOd69EZ_hYMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerf9BBMM31IYFM7s9KCkPtN0TDDvwZ4L13jim7frW0OqYMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmv4Isuoo9GoAlHFdvAKBQ9JTnAAYq_vHfe_gYH7AYylQMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code0NCln6McSmZ_45y_2fba4abMQN_UtuuCLMF8CIDX0EVycMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codexH0FAxmEXK0FsbbPLcyrNQARVsWmjZmRATJQQPpFi68Meta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeTPTP6qeQd3XHYDFfXH_zM_u5uUX7gkR60PUTbF5wT4EMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerBcDuUmWdTy2vxbjyu1yjku_tlGGk9JvcSmhcd0d7_SAMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmP_45Ilu6elWk6xILnBiC3tGnVGy7VjJ8R6mP2Ghwg4w_45UMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeO0WDOi_R97XJutvwxOI4DSpJ_45HEKyQ7BMNDj0ton_wQMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexEKjyJ3nv8ECx8YD625Ystf4_45TUC6LY1gF268lMHlTGAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeIvY52QMc2ZGWY_6tFuym8OSB00sAUpNJ6AmuwQlR5owMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplekKN8oiweXgvzxUojzZTmFMLg1YiRytGy2oLQ2bNoUJwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email54w6DiLTssCuKePQc3QgibaWHySjFFl5BEFEaAcaaDoMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmNSnb_45VA7OtjyrEuzIeZN9BPXarisjLWDJDGSy4fMCCoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentaX12evWfVBPAUHiJT7D0JstHGXBfGTRE7S1oZe8Sb5QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhig9guEPBBtUqTpiIscyPAULppJv39KQk6IjuVCmimQMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeFo4frCV_93hKpFjPL9PFPXKHWaMnXxX2qYTXKk0NKnUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code81F_C3A0JWgzfSaWhkPQWNVX6_opArJGYwPxiEVFaNwMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordL6DR7m9sqr9RyOw7ms4fpCVNbdsHQona8iVSr8rihL8Meta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerNPvgA2D04n8vezOB22bsPZjKujrhOVPeoYkptw_Fi_45oMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeUYzFuphbXsqfRE7n9jay_45cjeqiJNv_aQbv_8O3rRebgMeta || {},
    component: () => import("/codebuild/output/src3834588611/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3834588611/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]